import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "layouts/MainLayout";
import LayoutEvent from "@pages/Events/NewYearAndChristmas_2024/LayoutEvent";
import LayoutEventWorldCup from "@pages/Events/MiniGame/LayoutEvent";
import { useQuery } from "react-query";
// import { getCheckStatusEvent } from "dataLayer/product";
import { getMiniGameGetMiniGameQuery } from "dataLayer/miniGame";

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => {
  // const { data: statusEvent } = useQuery(getCheckStatusEvent());
  const { data } = useQuery(getMiniGameGetMiniGameQuery());


  return (
    <>
      {((data?.is_show === 0 && data?.is_finished == 0) || data?.is_show == 1) ? <LayoutEventWorldCup statusEvent={data} /> : null}
      {/* {statusEvent?.is_show ? <LayoutEvent statusEvent={statusEvent}/> : null} */}
      <Route
        {...rest}
        render={(props) => {
          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }}
      />
    </>
  );
};

AppRoute.defaultProps = {
  layout: MainLayout,
};

export default AppRoute;
